export const setItem = (key, value) => {
  if (sessionStorage) {
    const data = JSON.stringify(value);
    sessionStorage.setItem(key, data);
  }
};

export const getItem = (key) => {
  if (sessionStorage) {
    const data = sessionStorage.getItem(key);
    return JSON.parse(data);
  }
  return '';
};

export const removeItem = (key) => {
  if (sessionStorage) {
    sessionStorage.removeItem(key);
  }
};
